export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/illustration.61dae3c.svg";